<div class="spinner">
  <mat-spinner class="spinner-circle" [diameter]="30"></mat-spinner>
</div>
